<div class="ab-list-item-inner flex w-100 activity-type--upload">
  <span class="ab-list-item__icon">
    <span class="ab-fa-stacked--v2">
      <i class="icon fal fa-pen-to-square ab-stacked-icon"></i>
      <i class="icon fal fa-share-alt ab-stacked-icon with-shadow--white"></i>
    </span>
  </span>

  <div class="ab-list-item__content">
    <div class="summary">
      <span class="actor">{{item?.user?.name}}</span>
      removed the following connection from a list of {{payload.entitiesAffected}} entities using bulk edit.
    </div>
    <div class="details">
      <app-connection-type-name [connectionType]="entityConnectionType"></app-connection-type-name>
      <a [routerLink]="['/entity/view', entity?.id]"
         queryParamsHandling="preserve"
         class="attached-user user-profile-link ml-0050">{{entity | fullName}}</a>
    </div>

  </div>
  <app-activity-event-timestamp [item]="item"
                                class="ab-list-item__timestamp">
  </app-activity-event-timestamp>
</div>
